import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { MASKS } from 'ng-brazil';
import { CollaboratorsGroupPaged, Group, GroupColaborator, GroupCollaboratorAlter, GroupCollaboratorDelete, GroupProduct } from 'src/app/models/group';
import { ColaboratorsGroupService } from 'src/app/services/group/colaborators-group.service';
import { GroupService } from 'src/app/services/group/group.service';
import { LocalStoreKeys } from 'src/app/shared/helpers/localstorage/local-store';
import { NewAlertService } from 'src/app/shared/components/new-alert/new-alert.service';
import { CartaoService } from 'src/app/services/cartao.service';
import { ContratoService } from 'src/app/services/contrato.service';
import { CartaoCadastro } from 'src/app/models/cartao-cadastro';
import { CartaoPeriodoPadrao } from 'src/app/shared/enums/cartao-periodo-padrao.enum';
import { ProductsGroupService } from 'src/app/services/group/products-group.service';
import { environment } from 'src/environments/environment';
import { CentroCustoService } from 'src/app/services/centro-custo.service';
import { DepartamentoService } from 'src/app/services/departamento.service';
import { UnidadeService } from 'src/app/services/unidade.service';
import { CentroCusto } from 'src/app/models/centro-custo';
import { Unidade } from 'src/app/models/unidade';
import { Departamento } from 'src/app/models/departamento';
import { FormControl } from '@angular/forms';
import { BooleanConverter } from 'src/app/shared/helpers/converters/boolean-converter';
import { ParametrosKey } from 'src/app/shared/enums/parametros.enum';
import { ColaboradorFilterOptions } from 'src/app/shared/helpers/models/colaborador-filter-options';
import { CollaboratorFilter } from 'src/app/models/collaborator-filter';
import { ParametrosDataService } from 'src/app/services/parametros-data.service';
import { ApiError } from 'src/app/shared/enums/api-error.enum';

@Component({
  selector: 'app-grupo-list-collaborator',
  templateUrl: './grupo-list-collaborator.component.html',
  styleUrls: ['./grupo-list-collaborator.component.css']
})
export class GrupoListCollaboratorComponent implements OnInit {

    public MASKS = MASKS;
    public group;
    public groupCollaborators: Array<GroupColaborator>;
    public cpfMask: Array<string>;
    public groups: Array<Group>;
    public currentUser;
    public selectedItem;
    public selectedGroup;
    public request: GroupCollaboratorAlter;
    public deleteRequest: GroupCollaboratorDelete;
    public valorBusca: string;

    public productsByGroup: Array<GroupProduct>;
    public productFlexGroup: GroupProduct;
    groupCollaboratorsPaged: CollaboratorsGroupPaged;

    public cartoes: CartaoCadastro[] = [];
    public centrosCustosList: CentroCusto[];
    public unidadesList: Unidade[];
    public departamentosList: Departamento[];

    //#region filter form
    public nameCtrl: FormControl = new FormControl();
    public documentCtrl: FormControl = new FormControl();
    public registerCtrl: FormControl = new FormControl();
    public departmentCtrl: FormControl = new FormControl();
    public costCenterCtrl: FormControl = new FormControl();
    public unitCtrl: FormControl = new FormControl();
    //#endregion

    //#region filter
    public isMobile = false;
    public exibirFiltro = true;
    public filtroOn: boolean = false;
    public filtroCodigo = '';
    public filtroNome = '';
    public filtroCPF = '';
    public filtroMatricula = '';
    public filtroAplicativo = '';
    public filtroPesquisa = '';
    public filtroUnidade: number[] =[];
    public filtroDepartamento: number[] = [];
    public filtroCentroCusto: number[] = [];
    //#endregion

    private parametros: { [key: string]: string };
    public labelMatricula = 'Matrícula';
    public labelCentroCusto = 'Centro de Custo';
    public labelUnidade = 'Unidade';
    public labelDepartamento = 'Departamento';
    public labelSituacao = 'Situação';

    // páginação
    currentPage = 1;
    page = 1;
    offset = 0;
    showItem = '10';
    totalItems = 0;
    totalPages: number;
    collumnName = "name";

    constructor(private modalService: NgbModal, private collaboratorGroupService: ColaboratorsGroupService,
            private groupService: GroupService, private router: Router, private alertService: NewAlertService,
            private contratoService: ContratoService, private cartaoService: CartaoService,
            private productsGroupService: ProductsGroupService, private centroCustoService: CentroCustoService,
            private unidadeService: UnidadeService, private departamentoService: DepartamentoService,private parametrosDataService: ParametrosDataService) {
                this.group = JSON.parse(sessionStorage.getItem('Grupo'));
                this.currentUser = JSON.parse(localStorage.getItem(LocalStoreKeys.currentUser));
            }

    ngOnInit() {
        this.loadViewConfig();
        this.callGroupCollaborator(1);
        this.loadFiltroDropDown();
    }

    loadViewConfig() {
        this.parametros = this.parametrosDataService.currentParametrosValue;
        if (this.parametros) {
            if (this.parametros[ParametrosKey.exibirFiltrosColaboradores]) {
                this.exibirFiltro = BooleanConverter.getBoolean(
                    this.parametros[ParametrosKey.exibirFiltrosColaboradores]
                );
            } else {
                this.exibirFiltro = true;
            }

            if (
                this.parametros[
                ParametrosKey.labelPersonalizadaMatriculaColaborador
                ]
            ) {
                this.labelMatricula = this.parametros[
                    ParametrosKey.labelPersonalizadaMatriculaColaborador
                ];
            } else {
                this.labelMatricula = 'Matrícula';
            }

            if (
                this.parametros[
                ParametrosKey.labelPersonalizadaCentroCustoColaborador
                ]
            ) {
                this.labelCentroCusto = this.parametros[
                    ParametrosKey.labelPersonalizadaCentroCustoColaborador
                ];
            } else {
                this.labelCentroCusto = 'Centro de Custo';
            }

            if (
                this.parametros[
                ParametrosKey.labelPersonalizadaUnidadeColaborador
                ]
            ) {
                this.labelUnidade = this.parametros[
                    ParametrosKey.labelPersonalizadaUnidadeColaborador
                ];
            } else {
                this.labelUnidade = 'Unidade';
            }

            if (
                this.parametros[
                ParametrosKey.labelPersonalizadaDepartamentoColaborador
                ]
            ) {
                this.labelDepartamento = this.parametros[
                    ParametrosKey.labelPersonalizadaDepartamentoColaborador
                ];
            } else {
                this.labelDepartamento = 'Departamento';
            }

            if (
                this.parametros[
                ParametrosKey.labelPersonalizadaStatusColaborador
                ]
            ) {
                this.labelSituacao = this.parametros[
                    ParametrosKey.labelPersonalizadaStatusColaborador
                ];
            } else {
                this.labelSituacao = 'Situação';
            }
        }
    }

    callGroupCollaborator(event) {

        this.page = event;
        this.currentPage = event;

        const offset = this.currentPage - 1;

        const filterOptions = new ColaboradorFilterOptions();

        const filterObject = new CollaboratorFilter();

        filterObject.query = this.filtroPesquisa;
        filterObject.name = this.filtroNome;
        filterObject.document = this.filtroCPF;
        filterObject.register = this.filtroMatricula;

        filterObject.costCenter = this.filtroCentroCusto;
        filterObject.unit = this.filtroUnidade;
        filterObject.departament = this.filtroDepartamento;

        // parametros
        if (this.parametros[ParametrosKey.permitirBuscaNomeColaboradores]) {
            filterOptions.permitirBuscarNome = BooleanConverter.getBoolean(
                this.parametros[ParametrosKey.permitirBuscaNomeColaboradores]
            );
        }
        if (this.parametros[ParametrosKey.permitirBuscaCPFColaboradores]) {
            filterOptions.permitirBuscarCPF = BooleanConverter.getBoolean(
                this.parametros[ParametrosKey.permitirBuscaCPFColaboradores]
            );
        }
        if (
            this.parametros[
            ParametrosKey.permitirBuscaNomeIncrementalColaboradores
            ]
        ) {
            filterOptions.permitirBuscarNomeLike = BooleanConverter.getBoolean(
                this.parametros[
                ParametrosKey.permitirBuscaNomeIncrementalColaboradores
                ]
            );
        }
        if (
            this.parametros[
            ParametrosKey.permitirBuscaCPFIncrementalColaboradores
            ]
        ) {
            filterOptions.permitirBuscarCPFLike = BooleanConverter.getBoolean(
                this.parametros[
                ParametrosKey.permitirBuscaCPFIncrementalColaboradores
                ]
            );
        }
        if (this.parametros[ParametrosKey.permitirBuscaVaziaColaboradores]) {
            filterOptions.permitirBuscarVazio = BooleanConverter.getBoolean(
                this.parametros[ParametrosKey.permitirBuscaVaziaColaboradores]
            );
        }


        this.collaboratorGroupService.getColaborators(this.group.guidID, offset, parseInt(this.showItem), filterObject, filterOptions).subscribe(response => {
            if (response.status === ApiError.Sucesso) {

                this.groupCollaboratorsPaged = response.result;
                this.groupCollaborators = this.groupCollaboratorsPaged.collaborators;

                this.totalItems = response.result.totalResults;
                this.totalPages = response.result.totalPages;

                for (const s of this.groupCollaborators) {

                    const tam = environment.TOTAL_CARACTERE_CPF - s.collaboratorDocument.length;
                    let str = s.collaboratorDocument.toString();
                    for (let i = 0; i < tam; i++) {
                        str = '0' + str;
                    }
                    s.collaboratorDocument = str;
                }
            } else {
                this.alertService.error(response.message);
            }
        }, error => {
            this.alertService.error('Ocorreu um erro ao buscar os favorecido, tente novamente');
        });
    }

    callProductsOfGroup(guidDoGrupo) {
        this.productsGroupService.getGroupsByGroup(guidDoGrupo).
        subscribe(
            response => {
                if (response.status === 1) {
                    this.productsByGroup = [];
                    response.result.forEach(obj => {
                        if (obj.productCategory !== 2) {
                            this.productsByGroup.push(obj);
                        } else {
                            this.productFlexGroup = obj;
                        }
                    });
                } else {
                    this.alertService.error(response.message);
                }
            }, error => {
                this.alertService.error('Ocorreu um erro ao listar os produtos do grupo, tente novamente');
            });
    }

    callAlterGroup(req: GroupCollaboratorAlter, colaboradorId) {

        this.collaboratorGroupService.updateGroup(req).subscribe(response => {
            if (response.status === 1) {

                // tslint:disable-next-line: prefer-const
                let cartaoAtualiza: CartaoCadastro[] = [];
                // tslint:disable-next-line: prefer-const
                let cartaoInativa: CartaoCadastro[] = [];
                // tslint:disable-next-line: prefer-const
                let cartaoCria: CartaoCadastro[] = [];

                this.cartoes.forEach(obj2 => {
                    obj2.ativo = false;
                    this.productsByGroup.forEach(obj => {
                    // if(obj.productName)
                        // Verifica se os produtos são o produto é o mesmo
                        // tslint:disable-next-line: triple-equals
                        if (obj.productGuid == obj2.produtoGuid) {

                            obj2.ativo = true;
                            obj2.valorPadrao = obj.value;
                            obj2.cartaoPeriodoPadrao = obj.standardPeriodCard;

                            if (obj2.valorPadrao <= 0) {
                                // erro = true;
                            } else {
                                // verifica se já possui cartão
                                // tslint:disable-next-line: triple-equals
                                if (obj2.cartaoId == 0) {
                                    obj2.ativo = true;
                                    cartaoCria.push(obj2);

                                } else {
                                    cartaoAtualiza.push(obj2);

                                }
                            }
                        } else {

                            // inativa o cartão
                            if (obj2.cartaoId >= 0) {
                                this.cartaoService.update(obj2.cartaoId, obj2.cedenteContratoId, this.currentUser.token.assignorGuid, obj2).toPromise().then(
                                    resInativa => {
                                        if (resInativa.status !== 1) {
                                            // erro = true;
                                        }
                                    }
                                );
                            }
                        }

                    });

                });
                cartaoAtualiza.forEach(obj2 => {
                    this.cartaoService.update(obj2.cartaoId, obj2.cedenteContratoId, this.currentUser.token.assignorGuid, obj2).toPromise().then(
                        resAtualiza => {
                            if (resAtualiza.status !== 1) {
                                // erro = true;
                            }
                        }
                    );
                });
                cartaoCria.forEach(obj2 => {
                    this.cartaoService.add(colaboradorId, obj2.cedenteContratoId, this.currentUser.token.assignorGuid, obj2).toPromise().then(
                        resCria => {

                            if (resCria.status !== 1) {
                                // erro = true;
                            }
                        }
                    );
                });
                this.closeModal();
                /* this.router.navigate(['portal/grupos/list-collaborator']); */
                window.location.reload();
            } else {
                this.alertService.error(response.message);
            }
        }, error => {
            this.alertService.error('Ocorreu um erro ao trocar o favorecido de grupo, tente novamente');
        });
    }

    callRemoveCollaboratorGroup(req: GroupCollaboratorDelete) {
        this.collaboratorGroupService.removeCollaborator(req).subscribe(response => {
            if (response.result) {
                this.router.navigate(['portal/grupos/detalhe']);
                /* window.location.reload(); */
            } else {
                this.alertService.error(response.message);
            }
        }, error => {
            this.alertService.error('Ocorreu um erro ao remover o favorecido do grupo, tente novamente');
        });
    }

    removerGrupo(colaborador: any) {
        this.deleteRequest = {
            collaboratorIDs: [colaborador.collaboratorID],
            groupGuid: this.group.guidID
        };

        this.callRemoveCollaboratorGroup(this.deleteRequest);
    }

    moverGrupo(content: any, colaborador: Group) {
        this.selectedItem = colaborador;

        this.groupService.getGroupsByCedente(this.currentUser.token.assignorGuid).subscribe(response => {
            if (response.status === 1) {
                this.groups = response.result.filter(element => element.guidID !== this.group.guidID);
            }
        });

        this.modalService.open(content, { centered: true, size: 'xl' });
    }

    selectElement(item) {
        this.selectedGroup = item;
    }

    finalizar() {

        this.request = {
            groupGuid: this.group.guidID,
            newGroupGuid: this.selectedGroup.guidID,
            collaboratorIDs: [this.selectedItem.collaboratorID]
        };
        this.callProductsOfGroup(this.selectedGroup.guidID);

        this.getCartaoFlex(this.selectedItem.collaboratorID);



    }

    getCartaoFlex(colaboradorId) {
        this.contratoService.getContracts(this.currentUser.token.assignorGuid).subscribe(
            response => {
                if (response.status === 1) {
                    this.cartoes = [];
                    if (response.result) {
                        for (const s of response.result) {

                                this.cartaoService.getValid(colaboradorId, s.id, this.currentUser.token.assignorGuid).subscribe(
                                    responseCartao => {

                                        if (responseCartao.status === 1) {
                                            const cartaoExistente = new CartaoCadastro(responseCartao.result.valorPadrao, responseCartao.result.cartaoPeriodoPadraoId);
                                            cartaoExistente.cartaoId = responseCartao.result.cartaoId;
                                            cartaoExistente.produtoGuid = s.productEligibility.product.produtoGuid.toLowerCase();
                                            cartaoExistente.descricaoProduto = s.productEligibility.product.descricaoProduto;
                                            cartaoExistente.cedenteContratoId = s.id;
                                            cartaoExistente.ativo = responseCartao.result.ativo;
                                            cartaoExistente.valorPadrao = s.standardValue;


                                            this.cartoes.push(cartaoExistente);


                                        } else {
                                            const cartaoNovo = new CartaoCadastro(0, CartaoPeriodoPadrao.Mensal);
                                            cartaoNovo.cartaoId = 0;
                                            cartaoNovo.produtoGuid = s.productEligibility.product.produtoGuid.toLowerCase();
                                            cartaoNovo.descricaoProduto = s.productEligibility.product.descricaoProduto;
                                            cartaoNovo.cedenteContratoId = s.id;
                                            cartaoNovo.ativo = false;
                                            cartaoNovo.valorPadrao = s.standardValue;

                                            this.cartoes.push(cartaoNovo);

                                        }


                                    }
                                );

                        }
                        this.callAlterGroup(this.request, this.selectedItem.collaboratorID);
                    }
                else {
                    this.alertService.error('Ocorreu um erro ao carregar os incentivos');
                }
            }
            else {
                this.alertService.error('Ocorreu um erro ao carregar os benefícios');
            }
        });
    }

    public loadFiltroDropDown() {
        this.centroCustoService
            .getAll(this.currentUser.token.assignorGuid)
            .subscribe(response => {
                this.centrosCustosList = response.result;
                /* this.centrosCustosList.forEach(obj => {
                    this.filtroCentroCustoDropDownList.push(
                        new DropDownItem(obj.centroCustoId.toString(), obj.nome)
                    );
                }); */
            });

        this.unidadeService
            .getAll(this.currentUser.token.assignorGuid)
            .subscribe(response => {
                this.unidadesList = response.result;
                /* this.unidadesList.forEach(obj => {
                    this.filtroUnidadeDropDownList.push(
                        new DropDownItem(obj.unidadeId.toString(), obj.nome)
                    );
                }); */
            });

        this.departamentoService
            .getAll(this.currentUser.token.assignorGuid)
            .subscribe(response => {
                this.departamentosList = response.result;
                /* this.departamentosList.forEach(obj => {
                    this.filtroDepartamentoDropDownList.push(
                        new DropDownItem(
                            obj.departamentoId.toString(),
                            obj.nome
                        )
                    );
                }); */
            });

        /* this.dropDownSettings = {
            singleSelection: false,
            idField: 'ITEM_ID',
            textField: 'ITEM_TEXT',
            selectAllText: 'Selecionar Tudo',
            unSelectAllText: 'Desmarcar Tudo',
            searchPlaceholderText: 'Buscar',
            allowSearchFilter: true,
            itemsShowLimit: 3
        }; */
    }

    showItemChanged(event) {
        this.showItem = event;
        this.callGroupCollaborator(1);
    }

    showFilter(content: any) {
        this.modalService.open(content, { centered: true, size: 'lg' });
    }

    applyFilter() {

        this.filtroNome = this.nameCtrl.value;
        this.filtroCPF = this.documentCtrl.value;
        this.filtroMatricula = this.registerCtrl.value;
        this.filtroCentroCusto = this.costCenterCtrl.value;
        this.filtroDepartamento = this.departmentCtrl.value;
        this.filtroUnidade = this.unitCtrl.value;

        if(
            this.filtroNome == null &&
            this.filtroCPF == null &&
            this.filtroMatricula == null &&
            this.filtroCentroCusto == null &&
            this.filtroDepartamento == null &&
            this.filtroUnidade == null
        ){
            this.filtroOn = false;
        } else {
            this.filtroOn = true;
            this.callGroupCollaborator(1)
            this.modalService.dismissAll();
        }

    }

    deleteFilter(){
        this.filtroNome = "";
        this.filtroCPF = "";
        this.filtroMatricula = "";
        this.filtroCentroCusto = [];
        this.filtroUnidade = [];
        this.filtroDepartamento = [];
        this.filtroOn = false;

        this.callGroupCollaborator(1);
    }

    closeModal() {
        const element = document.getElementById('buttonCloseModal') as HTMLElement;
        element.click();
    }

    back() {
        this.router.navigate(['portal/grupos/detalhe']);
    }

}
